import { AxiosInstance } from "axios";
import { ApiRouteHelpers } from "../../../root/apiRoutes";
import { OrganizationSurveyDto } from "../dto/org/OrganizationSurveyDto";
import { PatchOrganizationSurveyAnswerRequest } from "../dto/org/OrganizationSurveyRequestDto";
import { OrganizationPublicId } from "../Types";

export class OrgSurveyController {
  constructor(private axios: AxiosInstance) {}

  public getAnswersForSurvey = async (
    organizationId: OrganizationPublicId,
    surveyName: string,
  ): Promise<OrganizationSurveyDto> => {
    const url = ApiRouteHelpers.organization.survey(organizationId, surveyName);
    const response = await this.axios.get<OrganizationSurveyDto>(url);

    return response.data as OrganizationSurveyDto;
  };

  public patchAnswersForSurvey = async (
    organizationId: OrganizationPublicId,
    surveyName: string,
    updateQuestionsDto: PatchOrganizationSurveyAnswerRequest[],
  ): Promise<OrganizationSurveyDto> => {
    const url = ApiRouteHelpers.organization.survey(organizationId, surveyName);
    const response = await this.axios.patch<OrganizationSurveyDto>(url, updateQuestionsDto);
    return response.data as OrganizationSurveyDto;
  };
}
